import { render } from "./ColoredIcon.vue?vue&type=template&id=162c1f34"
import script from "./ColoredIcon.vue?vue&type=script&lang=js"
export * from "./ColoredIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__